import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
} from "@mui/material"
import { treatView, viewControlInTreatment } from "@/gluelayer"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { UText } from "@/components/index"
import {
  setOpenOrderSplit,
  setOpenStlPrint,
  setStageShowType,
  setIsCreateNewRefinement,
} from "@/UDTreat/udTreatSlice"
import { OrderStlPrint } from "../OrderStlPrint/OrderStlPrint"
import Order from "@/UDTreat/Order/Order"
import { orderView, wasmModule } from "@/gluelayer"
import ReviewPrint from "../OrderStlPrint/ReviewPrint"

export const OrderSplit = ({ setisClickOrder }) => {
  const {
    openOrderSplit,
    openStlPrint,
    openReviewPrint,
    openLabelPreview,
    openUndercutPreview,
    openTrimPreview,
  } = useAppSelector((state: RootState) => state.udTreatService)
  const dispatch = useAppDispatch()
  const isSplitWasm = useRef(false)
  const getOrderContainer = () => {
    return (
      <>
        <Box
          sx={{
            display: openReviewPrint ? "none" : openStlPrint ? "block" : "none",
          }}
        >
          <OrderStlPrint />
        </Box>
        <Box
          sx={{ display: openReviewPrint ? "block" : "none", height: "100%" }}
        >
          <ReviewPrint />
        </Box>
        <Box
          sx={{ display: !openStlPrint && !openReviewPrint ? "block" : "none" }}
        >
          {!openStlPrint && !openReviewPrint && <Order />}
        </Box>
      </>
    )
  }

  const closeOrderSplit = () => {
    dispatch(setOpenOrderSplit(false))
    if (openStlPrint) {
      treatView.Open(false)
      dispatch(setStageShowType("normal"))
      dispatch(setOpenStlPrint(false))
      wasmModule.statusController.ResizeRenderer(1)
    }
    // debug code:
    if (wasmModule.moduleManager.GetModulePrintSelection()) {
      wasmModule.moduleManager.SwitchModulePrintSelection(false)
      wasmModule.moduleManager.AutoOpenModulesForSetup()
    }

    /**
     * 关闭页面时，将WASM部分还原
     */
    // to do:
    //orderView.splitPageForOrder(false)
  }

  /**
   * 打开页面时，将WASM部分分割成左右两部分
   */
  // to do:
  // useEffect(() => {
  //   if (openOrderSplit && !isSplitWasm.current) {
  //     orderView.splitPageForOrder(true)
  //     isSplitWasm.current = true
  //   }
  // }, [openOrderSplit])

  // close split window change isClickOrder
  useEffect(() => {
    return () => {
      setisClickOrder(false)
    }
  }, [])
  return (
    <Box
      id="orderSplit"
      sx={{
        backgroundColor: "#f7f8f9",
        width: "60%",
        height: "calc(100% - 40px)",
        position: "absolute",
        top: "40px",
        right: "0",
        zIndex: "10",
        overflowY: "auto",
      }}
    >
      {openStlPrint || openReviewPrint ? (
        <IconButton
          aria-label="close"
          onClick={() => {
            closeOrderSplit()
          }}
          disabled={openLabelPreview || openUndercutPreview || openTrimPreview}
          sx={{
            opacity: "0.5",
            background: (theme) => theme.palette.grey[300],
            boxShadow:
              "0px 1px 18px 0px  rgba(0, 0, 0, 0.12), 0px 6px 10px 0px  rgba(0, 0, 0, 0.14), 0px 3px 5px -1px  rgba(0, 0, 0, 0.20)",
            position: "absolute",
            right: 12,
            top: 10,
            color: `rgba(0,0,0,0.87)`,
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : (
        <IconButton
          aria-label="close"
          onClick={() => {
            closeOrderSplit()
          }}
          sx={{
            position: "absolute",
            right: 12,
            top: 10,
            color: (theme) => theme.palette.grey[500],
            zIndex: 1,
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
      <Box
        id={"splitContainer"}
        sx={{
          width: "100%",
          height: "100%",
          padding: "16px 40px 40px 40px",
          overflowY:
            openLabelPreview || openUndercutPreview || openTrimPreview
              ? "hidden"
              : "auto",
          position: "relative",
        }}
      >
        <Box
          id={"printMask"}
          sx={{
            position: "fixed",
            width: "60%",
            height: "100%",
            top: "40px",
            left: "40%",
            background: "rgba(0,0,0,0.5)",
            zIndex: 1,
            display:
              openLabelPreview || openUndercutPreview || openTrimPreview
                ? "block"
                : "none",
          }}
        ></Box>
        {getOrderContainer()}
        {/* <Box sx={{ width: "100%", textAlign: "center", marginBottom: "38px" }}>
          <UText variant={"h4"}>{`Order STL Print`}</UText>
        </Box> */}
      </Box>
    </Box>
  )
}
